import { render, staticRenderFns } from "./ReceptionPatientEditor.vue?vue&type=template&id=1323f30b&scoped=true&"
import script from "./ReceptionPatientEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionPatientEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1323f30b",
  null
  
)

export default component.exports